const HomeShowcase = () => {
  return (
    <section className="py-32 px-6 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-rose-50 dark:from-gray-900 dark:via-gray-800 dark:to-purple-900">
        <div
          className="absolute inset-0 opacity-30 dark:opacity-20"
          style={{
            backgroundImage:
              `radial-gradient(circle at 25% 25%, rgba(244, 114, 182, 0.1) 0%, transparent 50%), radial-gradient(circle at 75% 75%, rgba(168, 85, 247, 0.1) 0%, transparent 50%)`,
          }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <p className="text-sm font-light tracking-[0.3em] uppercase text-gray-500 dark:text-gray-400 mb-4">Couture Intelligence</p>
          <h2 className="text-5xl md:text-7xl font-thin mb-6 bg-gradient-to-r from-gray-900 via-gray-700 to-gray-900 dark:from-white dark:via-gray-200 dark:to-white bg-clip-text text-transparent leading-tight">
            Styled by AI.
            <br />
            <span className="italic font-light">Inspired by You.</span>
          </h2>
          <div className="w-24 h-px bg-gradient-to-r from-transparent via-pink-400 to-transparent mx-auto" />
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          {[
            {
              category: "Avant-Garde Minimalism",
              description: "Clean lines meet architectural silhouettes. Precision in every detail, elegance in restraint.",
              accent: "from-slate-400 to-gray-600",
              icon: (
                <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={0.5} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                </svg>
              ),
            },
            {
              category: "Contemporary Luxe",
              description: "Where modern sophistication meets timeless allure. Elevated essentials for the discerning connoisseur.",
              accent: "from-rose-400 to-pink-600",
              icon: (
                <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={0.5} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                </svg>
              ),
            },
            {
              category: "Editorial Statement",
              description: "Bold narratives through fabric and form. Runway-ready pieces that command attention and inspire awe.",
              accent: "from-purple-400 to-indigo-600",
              icon: (
                <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={0.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              ),
            },
          ].map(({ category, description, accent, icon }, i) => (
            <div key={i} className="group relative">
              <div className="relative h-80 bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm border border-gray-200/50 dark:border-gray-700/50 rounded-none overflow-hidden transition-all duration-700 group-hover:shadow-2xl group-hover:shadow-pink-500/10 dark:group-hover:shadow-purple-500/20">
                <div className={`absolute inset-0 bg-gradient-to-br ${accent} opacity-0 group-hover:opacity-5 transition-opacity duration-700`} />
                <div className="relative h-full flex flex-col justify-between p-8">
                  <div className={`text-gray-400 dark:text-gray-500 group-hover:text-transparent group-hover:bg-gradient-to-br group-hover:${accent} group-hover:bg-clip-text transition-all duration-500`}>
                    {icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-light mb-4 text-gray-900 dark:text-white tracking-wide">{category}</h3>
                    <p className="text-sm font-light text-gray-600 dark:text-gray-300 leading-relaxed tracking-wide">{description}</p>
                    <div className={`w-0 group-hover:w-12 h-px bg-gradient-to-r ${accent} mt-6 transition-all duration-700`} />
                  </div>
                </div>
                <div className="absolute top-0 right-0 w-0 group-hover:w-16 h-16 bg-gradient-to-bl from-white/20 to-transparent transition-all duration-700" />
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-16">
          <div className="flex space-x-2">
            <div className="w-2 h-2 rounded-full bg-pink-300/50" />
            <div className="w-2 h-2 rounded-full bg-purple-300/50" />
            <div className="w-2 h-2 rounded-full bg-indigo-300/50" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeShowcase;
